<template>
  <div class="link-text-router">
    <div
      v-if="!openUrl && name != 'SharedGroupWithConfirm' && name != 'Terms' && name != 'License'"
    >
      <router-link
        class="nav-link link-text-router-inner"
        :to="{ name: name }"
      >
        <component
          :is="iconName"
          class="icon-area"
          width="32"
          height="32"
          :fill-color="iconColor"
        />
        <div
          :class="textClassObject"
        >
          {{ labelText }}
        </div>
      </router-link>
    </div>
    <div v-else>
      <a
        v-if="name != 'SharedGroupWithConfirm' && name != 'Terms' && name != 'License'"
        :href="openUrl"
        class="nav-link pe-2"
        target="_blank"
      >
        <div class="text-underline" :class="textClassObject">{{ labelText }}</div>
      </a>
      <div
        v-else
        class="nav-link pe-2"
      >
        <div class="text-underline" :class="textClassObject">{{ labelText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import IconHomeworkMono from "@/components/atoms/icons/IconHomeworkMono.vue"
import IconQuestion from "@/components/atoms/icons/IconQuestion.vue"
import IconComment from "@/components/atoms/icons/IconComment.vue"

export default {
  name: "LinkTextRouter",
  components: {
    IconHomeworkMono,
    IconQuestion,
    IconComment,
  },
  props: {
    name: {
      type: String,
      default: function () {
        return ""
      },
    },
    iconName: {
      type: String,
      default: function () {
        return ""
      },
    },
    iconColor: {
      type: String,
      default: function () {
        return ""
      },
    },
    labelText: {
      type: String,
      default: function () {
        return ""
      },
    },
    fontColor: {
      type: String,
      default: function () {
        return ""
      },
    },
    openUrl: {
      type: String,
      default: function () {
        return ""
      },
    },
  },

  computed: {
    textClassObject: function () {
      return {
        "text-white": "text-white" === this.fontColor,
        "text-dark": "text-dark" === this.fontColor,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.link-text-router-inner {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 0px;
}
.icon-area {
  padding: 0px 5px 0px 10px;
}
.text-underline {
  text-decoration: underline;
  cursor: pointer;
}
</style>
